
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Cabserviceinlatur() {



const cardData = {
  keyword: 'Corporate Cab Services in Latur MIDC',
  heading: 'eTravo: Professional Corporate Cab Services in Latur MIDC',
  headingDescription: `eTravo provides reliable and efficient corporate cab services in Latur MIDC, serving businesses across manufacturing, agro-processing, and logistics sectors. Our solutions are built to simplify employee transport, executive movement, and client travel. With GPS-enabled, air-conditioned vehicles and professional drivers trained in corporate protocol, we ensure punctuality, safety, and comfort. Our flexible plans accommodate shift timings, inter-factory shuttles, and emergency bookings. Whether your need is for daily commutes, executive transfers, or corporate events, eTravo delivers a consistent and high-quality experience, helping industries in Latur operate without transport-related delays.`,

  top: 'Key Industrial and Business Hubs Served by eTravo in Latur MIDC',
  topPlaces: [
    {
      title: 'Latur MIDC Zone',
      description: `The heart of industrial activity in Latur, home to multiple manufacturing and agro-industrial units. eTravo provides multi-route staff cab services and on-demand executive transfers tailored to company schedules.`
    },
    {
      title: 'Latur Food Park',
      description: `An important agro-processing hub. eTravo supports daily transportation for factory staff and shift workers, optimizing vehicle allocation based on peak activity hours.`
    },
    {
      title: 'Latur Urban Business District',
      description: `The commercial zone of Latur where many corporate offices are based. We provide comfortable executive cab services and client transfer options for professional business environments.`
    },
    {
      title: 'Latur Railway Station',
      description: `We offer last-mile connectivity from the station to industrial zones for employees and corporate guests arriving from other regions.`
    },
    {
      title: 'MIDC Logistics Warehouses',
      description: `Large-scale storage and distribution hubs rely on eTravo for staff mobility, especially during loading/unloading shifts and inventory movements.`
    }
  ],

 services: [
  {
    name: 'Latur MIDC Corporate Cab Rentals',
    description: `Flexible and fully customizable corporate cab rental solutions designed for businesses operating in Latur MIDC. Choose from daily, weekly, or monthly plans based on your company’s travel demands. Ideal for transporting employees, executives, and business partners to and from industrial offices, meetings, or offsite events with guaranteed reliability and professional service.`
  },
  {
    name: 'Employee Transport Cab Latur MIDC',
    description: `Reliable employee transportation services tailored for factories and corporate offices in Latur MIDC. Our fleet supports shift-based scheduling, ensuring staff commutes are always timely and safe. Features include GPS-enabled vehicles, route optimization, and centralized control through a live tracking system for HR teams.`
  },
  {
    name: 'Business Cab Services Latur MIDC',
    description: `On-demand and pre-scheduled business cab solutions ideal for daily operations within and beyond the Latur MIDC area. Perfect for attending meetings, coordinating with suppliers, or visiting partner locations. Our business cabs are driven by courteous professionals, offering punctuality and a smooth ride experience to support your company’s productivity.`
  },
  {
    name: 'Corporate Staff Cabs Latur MIDC',
    description: `Route-based cabs designed for bulk staff transportation with fixed routes seating options, and smart scheduling for entry/exit shift coordination. Enhance operational efficiency with batch pickups, optimized drop-off points, and end-to-end fleet coordination for large or expanding teams in industrial estates.`
  },
  {
    name: 'Reliable Corporate Cab Service Latur MIDC',
    description: `Consistently dependable transport services trusted by local enterprises for years. Our focus is on punctuality, professional chauffeurs, and clean, well-maintained vehicles that reflect your company’s values. Each cab comes with safety features and 24/7 support to ensure seamless operations across departments.`
  },
  {
    name: 'AC Corporate Cabs Latur MIDC',
    description: `Air-conditioned cab services designed for Latur’s extreme weather conditions, particularly its long, dry summers. Ensure comfort for your employees and visitors during daily commutes or special corporate travels. Our AC fleet includes sedans, hatchbacks, and SUVs with excellent climate control and clean interiors.`
  },
  {
    name: 'Staff Pickup and Drop Cab Latur MIDC',
    description: `Round-the-clock staff pickup and drop services specially curated for organizations running multiple shifts, including night shifts. Maintain staff punctuality and reduce absenteeism with timely, reliable cabs operating across designated zones in and around the MIDC area.`
  },
  {
    name: 'Affordable Business Cab Rentals Latur MIDC',
    description: `Cost-effective cab rental plans for businesses of all sizes. Our packages include fuel-efficient vehicles and route pooling to optimize transport budgets. Get scalable plans suited for short-term and long-term corporate mobility with full visibility into expenses and driver logs.`
  },
  {
    name: 'Executive Cab Services Latur MIDC',
    description: `High-end cab services for senior management, board members, and visiting VIPs. Vehicles include premium sedans and SUVs with trained chauffeurs focused on professionalism, discretion, and customer care. A seamless experience tailored for high-value passengers, ensuring comfort and brand representation.`
  },
  {
    name: 'Monthly Corporate Cab Rentals Latur MIDC',
    description: `Monthly rental packages that simplify corporate transport management. Fixed pickup and drop points, transparent billing, dedicated support teams, and integration with HR attendance software make this a preferred choice for companies seeking efficiency and reliability in employee movement.`
  },
  {
    name: 'Industrial Area Employee Transport Latur MIDC',
    description: `Full-scale employee transport services with comprehensive coverage across all industrial belts in Latur MIDC. Maintain compliance with labor regulations through documented travel logs and scheduled reports. Ideal for companies looking to provide dependable daily commutes to factory and warehouse workers.`
  },
  {
    name: 'Corporate Client Cabs Latur MIDC',
    description: `Specially managed cab services for business clients and stakeholders visiting your offices or sites. Ensure a professional first impression with dedicated vehicles, uniformed drivers, and coordinated pickup/drop schedules directly from airports, hotels, or rail stations to your facilities.`
  },
  {
    name: 'Business Meeting Cabs Latur MIDC',
    description: `Quick-response cab services for executives heading to critical meetings, industrial audits, or vendor discussions. Book instantly with our smart scheduling platform and enjoy a smooth, professional journey experience in business-ready vehicles.`
  },
  {
    name: 'Latur Industrial Area Cab Hire',
    description: `Instant cab hire across Latur’s MIDC zones for urgent requirements such as material checks, audit visits, or coordination between departments. Vehicles can be deployed quickly and are managed by drivers familiar with the layout of industrial premises.`
  },
  {
    name: 'Corporate Shuttle Cabs Latur MIDC',
    description: `Group transport solutions via shuttles, mini-buses, and tempo travelers designed for mass employee movement. Ideal for shift changes, training programs, or coordinated offsite visits. Save costs and improve safety by reducing individual travel in favor of managed group mobility.` 
  }
],

  tableData: [
    ['Latur MIDC Corporate Cab Rentals', 'Employee Transport Cab Latur MIDC'],
    ['Business Cab Services Latur MIDC', 'Corporate Staff Cabs Latur MIDC'],
    ['Reliable Corporate Cab Service Latur MIDC', 'AC Corporate Cabs Latur MIDC'],
    ['Staff Pickup and Drop Cab Latur MIDC', 'Affordable Business Cab Rentals Latur MIDC'],
    ['Executive Cab Services Latur MIDC', 'Monthly Corporate Cab Rentals Latur MIDC'],
    ['Industrial Area Employee Transport Latur MIDC', 'Corporate Client Cabs Latur MIDC'],
    ['Business Meeting Cabs Latur MIDC', 'Latur Industrial Area Cab Hire'],
    ['Corporate Shuttle Cabs Latur MIDC', '']
  ],


"whychoose": [
  {
    "WhyChooseheading": "Dedicated Cab Services for Latur MIDC Industries",
    "WhyChoosedescription": "eTravo offers professional and dependable corporate cab services tailored to the needs of businesses operating in Latur MIDC—a rapidly growing industrial region known for agro-processing, manufacturing, and engineering sectors. Our services are crafted to ensure timely employee transportation, reduce absenteeism, and support smoother operational workflows. With end-to-end travel management, we help your business maintain punctuality, safety, and employee satisfaction."
  },
  {
    "WhyChooseheading": "Diverse and Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "We provide a wide range of vehicles including sedans for executives, MUVs for group travel, and SUVs for long-distance inter-office commutes. All our vehicles are air-conditioned, GPS-enabled, and undergo routine servicing to ensure passenger comfort, reliability, and safety throughout every journey."
  },
  {
    "WhyChooseheading": "Trained Drivers Familiar with Latur MIDC Routes",
    "WhyChoosedescription": "Our drivers are locally experienced, well-trained in safety protocols, and familiar with the internal layout and traffic patterns of Latur MIDC. They ensure timely pickups and drops even during peak hours, making them ideal partners for shift-based or time-sensitive transport requirements."
  },
  {
    "WhyChooseheading": "Customizable Transport Plans for Any Shift Pattern",
    "WhyChoosedescription": "We understand the unique needs of factories and industrial operations, which often run on rotating or round-the-clock shifts. That’s why we offer highly flexible booking options including scheduled shifts, multi-point pickups, and emergency ride requests tailored to your workforce."
  },
  {
    "WhyChooseheading": "Live GPS Tracking and Trip Monitoring",
    "WhyChoosedescription": "All rides can be tracked in real time by your admin or HR teams. GPS monitoring ensures greater visibility, enhanced security, and faster response in case of route changes, delays, or emergencies—giving you peace of mind and operational control."
  },
  {
    "WhyChooseheading": "Transparent Monthly Billing and Trip Logs",
    "WhyChoosedescription": "Our billing system is 100% transparent, with monthly GST-compliant invoices that include detailed trip logs, vehicle usage summaries, and fare breakdowns. This simplifies budgeting, auditing, and reimbursements for corporate finance teams."
  },
  {
    "WhyChooseheading": "Hygiene-Focused and Safety-Driven Travel",
    "WhyChoosedescription": "We maintain strict safety and hygiene protocols across our fleet. Vehicles are sanitized daily, and drivers adhere to health screening routines. This ensures a safe and clean environment for your employees, especially in group transport settings."
  },
  {
    "WhyChooseheading": "Dedicated Account Management for Corporates",
    "WhyChoosedescription": "Each corporate client is supported by a dedicated account manager responsible for coordinating bookings, addressing real-time queries, customizing services, and ensuring that your company’s transportation runs smoothly and efficiently every day."
  }
]
}

const faqData = [
  [
    {
      question: "Which areas of Latur MIDC do you cover?",
      answer: "We offer full coverage of Latur MIDC and nearby industrial clusters, ensuring seamless transportation for employees across all factory locations and business parks."
    },
    {
      question: "Can you handle multi-shift transport schedules?",
      answer: "Yes, our services are ideal for single, double, and rotating shifts. We provide tailored scheduling and dedicated vehicles to match your workforce requirements."
    },
    {
      question: "Do you provide consolidated monthly billing?",
      answer: "Absolutely. We generate detailed monthly invoices with trip-wise logs to help manage and reconcile corporate transport costs with ease."
    },
    {
      question: "Are your drivers background-verified and trained?",
      answer: "Yes, all drivers are background-verified and trained in customer service, safety standards, and local navigation for industrial zones like Latur MIDC."
    },
    {
      question: "Is real-time trip tracking available?",
      answer: "Yes, our vehicles are equipped with GPS tracking so you can monitor trips in real-time, enhancing security and operational oversight."
    },
    {
      question: "Do you offer dedicated support for corporate clients?",
      answer: "Yes, corporate clients are assigned a dedicated account manager and have access to priority support for bookings and service adjustments."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Nitin Gade",
    designation: "Admin Head, Latur AgroTech Pvt. Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo has completely streamlined our shift transport in Latur MIDC. Their punctual service and professional drivers make a big difference.”"
  },
  {
    name: "Ms. Rutuja Shinde",
    designation: "HR Manager, Latur Engineering Solutions",
    rating: [1, 1, 1, 1, 1],
    text: "“From flexible booking to detailed billing, eTravo has become our most dependable transport partner. Excellent service and support.”"
  }
];































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Latur MIDC",
  "image": "https://www.etravo.in/images/keyword/cab-service-latur-midc.jpg",
  "description": "Reliable corporate cab service in Latur MIDC offering employee transport, business travel, industrial area cabs, and affordable AC corporate rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1699",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/cab-service-latur-midc"
  }
};








    return (
        <div>
<Helmet>
  <title>Cab Service in Latur MIDC | Corporate & Industrial Cabs | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable corporate cab service in Latur MIDC for staff commute, business meetings, and industrial transport. Affordable AC corporate cabs available at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Cabserviceinlatur;